export default "__VITE_ASSET__1431773c__"